import { NotificationBar, TYPE_ORBITAL } from '@eventbrite/eds-notification';
import { gettext } from '@eventbrite/i18n';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import {
    getGoogleChromeUrlForCheckout,
    shareCheckoutUrl,
    shouldPerformTablessCheckout,
} from '../utils/browser';
import styles from './NotificationStylesForAsideAndSpan.rebranding.module.scss';

export const LimitedPaymentMethodsInMobileNotification: FunctionComponent<{
    isAppRebrandActive?: boolean;
}> = ({ isAppRebrandActive }) => {
    if (!shouldPerformTablessCheckout()) {
        return null;
    }

    return (
        <NotificationBar
            type={TYPE_ORBITAL}
            hasCloseButton={false}
            isAppRebrandActive={isAppRebrandActive}
        >
            <span
                className={classNames({
                    [styles['notification-bar']]: isAppRebrandActive,
                })}
                onClick={(event) => {
                    const target = event.target as HTMLElement;
                    const isClickingLink =
                        target.nodeName.toLowerCase() === 'a';

                    if (!isClickingLink) {
                        return;
                    }

                    shareCheckoutUrl();
                }}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: gettext(
                        'You can pay with a credit card and PayPal in the app. To pay with another method, <a href="%(openInBrowserUrl)s">open Eventbrite in your browser</a>.',
                        {
                            openInBrowserUrl: getGoogleChromeUrlForCheckout(),
                        },
                    ).toString(),
                }}
            />
        </NotificationBar>
    );
};
